document.addEventListener('DOMContentLoaded', () => {

    showBannerHead = false

    if (sessionStorage.getItem('banner_head') != "false") {
        showBannerHead = true
    }

    /**
     * banner on service
     * */
    const bannerHead = document.getElementById('banner-head')
    if(bannerHead && showBannerHead) {

        if (window.innerWidth > 768) {
            bannerHead.style.display = "flex"
        }

        const bannerHeadButtonClose = bannerHead.querySelector(".banners-head__close")
        if(bannerHeadButtonClose) {
            bannerHeadButtonClose.addEventListener("click", bannerHeadButtonCloseClick)
        }
        function bannerHeadButtonCloseClick() {
            sessionStorage.setItem('banner_head', 'false')
            bannerHead.style.display = "none"
        }
    }

    /**
     * banner on service mobile
     * */
    const bannerHeadMobile = document.getElementById('banner-headmobile')
    if(bannerHeadMobile && showBannerHead) {

        if (window.innerWidth <= 768) {
            bannerHeadMobile.style.display = "flex"
        }
    }



    showBannerHeadBlog = false

    if (sessionStorage.getItem('banner_head_blog') != "false") {
        showBannerHeadBlog = true
    }

    /**
     * banner on blog
     * */
    const bannerHeadBlog = document.getElementById('banner-blog')
    if(bannerHeadBlog && showBannerHeadBlog) {

        if (window.innerWidth > 768) {
            bannerHeadBlog.style.display = "flex"
        }

        const bannerHeadBlogButtonClose = bannerHeadBlog.querySelector(".banners-blog__close")
        if(bannerHeadBlogButtonClose) {
            bannerHeadBlogButtonClose.addEventListener("click", bannerHeadBlogButtonCloseClick)
        }
        function bannerHeadBlogButtonCloseClick() {
            sessionStorage.setItem('banner_head_blog', 'false')
            bannerHeadBlog.style.display = "none"
        }
    }

    /**
     * banner on blog mobile
     * */
    const bannerHeadBlogMobile = document.getElementById('banner-blogmobile')
    if(bannerHeadBlogMobile && showBannerHeadBlog) {

        if (window.innerWidth <= 768) {
            bannerHeadBlogMobile.style.display = "flex"
        }

        const bannerHeadBlogMobileButtonClose = bannerHeadBlogMobile.querySelector(".banners-blogmobile__close")
        if(bannerHeadBlogMobileButtonClose) {
            bannerHeadBlogMobileButtonClose.addEventListener("click", bannerHeadBlogMobileButtonCloseClick)
        }
        function bannerHeadBlogMobileButtonCloseClick() {
            sessionStorage.setItem('banner_head_blog', 'false')
            bannerHeadBlogMobile.style.display = "none"
        }
    }
});

